<template>
  <div class="product-society">
    <div class="info">
      <div class="title">社会治理</div>
      <div class="content">
        以“人文精神”和“法治精神”为本，以“高水平治理”与“高质量发展”为锚，依托认知智能引擎平台，构建基层治理的数字化产品平台，全面赋能基层智治、平安法治、产业发展、乡村振兴，持续提升基层社会治理的可塑性、客观性、便利性，全力推动社会治理实现社会化、法治化、智能化、专业化。
      </div>
    </div>
    <div class="plans">
      <div class="title">方案优势</div>
      <div class="desc">
        人文精神+法治精神&emsp;高水平治理+高质量发展
      </div>
      <div class="plan-box">
        <div
          class="plan-item"
          v-for="(item, index) in plans"
          :key="`plan-item${index + 1}`"
        >
          <img :src="item.icon" alt="" />
          <span class="text">{{ item.text }}</span>
          <span class="desc">{{ item.desc }}</span>
        </div>
      </div>
    </div>
    <div class="product">
      <div class="title">产品矩阵</div>
      <!-- <div class="desc">
        因地制宜选择不同应用模块进行组建，达到科学治理最佳成效
      </div> -->
      <div class="product-catgory">
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title1">
            基层智治
          </div>
          <PoliticalParty />
        </div>
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title2">
            平安法治
          </div>
          <LegalInstitutions />
        </div>
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title1">
            经济发展
          </div>
          <EconomicDevelopment />
        </div>
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title2">
            模型/算法/工具
          </div>
          <ModelAlgorithmTools />
        </div>
      </div>
    </div>
    <div class="cases">
      <div class="title">客户案例</div>
      <Case :data.sync="case_list" class="case-list" />
    </div>
    <div class="more">
      更多案例请联系我们
    </div>
    <div class="visitingCard">
      <VisitingCard :data="visitlist" />
    </div>
  </div>
</template>
<script>
import product_society_information from "@/../static/img/product/product_society_information.png";
import product_society_arithmetic from "@/../static/img/product/product_society_arithmetic.png";
import product_society_onestep from "@/../static/img/product/product_society_onestep.png";
import product_society_space from "@/../static/img/product/product_society_space.png";
import product_society_rule from "@/../static/img/product/product_society_rule.png";
import product_society_develop from "@/../static/img/product/product_society_develop.png";
import PoliticalParty from "./politicalparty.vue";
import LegalInstitutions from "./legalinstitutions.vue";
import EconomicDevelopment from "./economicDevelopment.vue";
import ModelAlgorithmTools from "./modelAlgorithmTools.vue";
import Case from "@/components/customerCase.vue";
import VisitingCard from "@/components/visitingCard.vue";

import shzl from "@/../static/img/product/shzl.svg";
import product_society_society_vx from "@/../static/img/product/product_society_society_vx.png";
export default {
  name: "product-society",
  components: {
    PoliticalParty,
    LegalInstitutions,
    Case,
    VisitingCard,
    EconomicDevelopment,
    ModelAlgorithmTools
  },
  data() {
    return {
      plans: [
        {
          text: "基层减负",
          icon: product_society_information,
          desc: ""
        },
        {
          text: "基层法治",
          icon: product_society_rule,
          desc: ""
        },
        {
          text: "经济发展",
          icon: product_society_develop,
          desc: ""
        },
        {
          text: "压责约权",
          icon: product_society_arithmetic,
          desc: ""
        },
        {
          text: "上下衔接",
          icon: product_society_space,
          desc: ""
        },
        {
          text: "多元共治",
          icon: product_society_onestep,
          desc: ""
        }
      ],
      case_list: [
        {
          title: "浙里兴村治社数字化系统",
          img: "../../../static/img/product/product_society_society_case1.png",
          video:
            "https://huayuan-1255423687.cos.ap-shanghai.myqcloud.com/video/zhili/xingcungongfu.mp4",
          content: `2022年1月在浙江某市全面推广，已列入全省数字化改革重大应用子场景和省委组织部重点培育多跨应用场景，相关应用场景介绍先后在<strong>${"浙江省委改革办《数字化改革（领跑者）》、《新华每日电讯》、《浙江日报》头版刊发"}，<strong>${"并获得2021年度浙江省改革突破奖"}。</strong>`,
          isplay: false
        },
        {
          title: "数字庄稼医院",
          img: "../../../static/img/product/product_society_society_case3.png",
          video: "",
          content: `“数字庄稼医院”为农服务平台通过构建农资服务、农技服务、农产行销和政策宣传等服务内容，形成农资公司、专家资源、经营网点的互惠互利，同时切实帮助农户增产增收。`,
          isplay: false
        },
        {
          title: "防返贫动态监测和帮扶数字化平台",
          img: "../../../static/img/product/product_society_society_case4.png",
          video: "",
          content: `华院计算在实践领域打造了以算法模型为核心的大数据防返贫动态监测治理体系，辅助健全防返贫帮扶工作机制，切实巩固脱贫攻坚成果的同时，为巩固拓展脱贫攻坚成果过渡期后政策帮扶提供科学决策依据。`,
          isplay: false
        },
        {
          title: "知识计算中心",
          img: "../../../static/img/product/product_society_society_case5.png",
          video: "",
          content: `作为产业大脑的核心驱动模块，知识计算中心基于产业数据仓构建，打通了行业 、 企业间的固有壁垒，更好赋能数字经济治理与发展。通过利用人工智能技术，构建全行业、全产品体系的产业知识中心，为产业发展决策提供能力支撑。`,
          isplay: false
        }
      ],
      visitlist: [
        // {
        //   department: "智算创新部门联系人",
        //   name: "徐女士",
        //   vx: product_society_society_vx,
        //   mail: "product@unidt.com"
        // },
        // {
        //   position: "智算创新业务微信公众号",
        //   department: "",
        //   name: "",
        //   vx: shzl,
        //   mail: ""
        // }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.product-society {
  width: 100%;
  padding: 96px 0px 0px;

  .info {
    width: 100%;
    height: 632px;
    background: url("../../../../static/img/product/product_society_bg.png")
      no-repeat 0 0 / 100%;
    overflow: hidden;

    .title {
      margin-top: 48px;
      font-size: 44px;
      font-weight: 500;
      color: #08204d;
      line-height: 60px;
      text-align: center;
    }

    .content {
      padding: 0 68px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      margin-top: 24px;
    }
  }

  .plans {
    height: 1000px;
    overflow: hidden;

    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }
    .desc {
      margin-top: 8px;
      font-size: 24px;
      color: #97a2b5;
      line-height: 52px;
      text-align: center;
    }

    .plan-box {
      width: 80%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;

      .plan-item {
        width: 240px;
        margin-bottom: 44px;
        display: flex;
        flex-direction: column;
        align-items: center;

        > img {
          width: 180px;
          height: 180px;
        }

        .text {
          margin-top: 8px;
          font-size: 32px;
          color: #08204d;
          line-height: 44px;
        }

        .desc {
          font-size: 24px;
          color: #97a2b5;
          line-height: 52px;
        }
      }
    }
  }

  .product {
    .title {
      font-size: 40px;
      color: #08204d;
      line-height: 56px;
      text-align: center;
      margin-top: 44px;
    }

    .desc {
      margin-top: 8px;
      font-size: 24px;
      color: #97a2b5;
      line-height: 52px;
      text-align: center;
    }

    .product-catgory {
      margin-top: 32px;

      .product-catgory-item {
        .product-catgory-item-title {
          width: 100%;
          height: 200px;
          line-height: 200px;
          font-size: 32px;
          color: #08204d;
          text-align: center;
        }

        .product-catgory-item-title1 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg1.png")
            no-repeat left center / 100%;
        }

        .product-catgory-item-title2 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg2.png")
            no-repeat left center / 100%;
        }
      }
    }
  }

  .cases {
    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }

    .case-list {
      width: calc(100% - 110px);
      margin: 24px 55px 0;
    }
  }

  .more {
    height: 52px;
    font-weight: 400;
    font-size: 22px;
    color: #97a2b5;
    line-height: 52px;
    text-align: center;
    font-style: normal;
    margin: 16px 0;
  }

  .visitingCard {
    width: calc(100% - 128px);
    padding: 40px 64px;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/society/index.vue